export type MedicaidStateRule = {
  medicaidAdultMinAge: number
}

export const MEDICAID_STANDARD_ADULT_MIN_AGE = 18

// medicaidAdultMinAge will be present for states whose adult definition differs from the standard 18+ for Medicaid bookings
export const MEDICAID_STATE_CONFIG: Record<string, MedicaidStateRule> =
  process.env.NEXT_PUBLIC_VERCEL_ENV === 'production'
    ? {
        MA: { medicaidAdultMinAge: 21 },
      }
    : {
        TX: { medicaidAdultMinAge: 21 },
      }

export const getMedicaidAdultMinAge = (stateCode?: string): number =>
  MEDICAID_STATE_CONFIG[stateCode?.toUpperCase()]?.medicaidAdultMinAge ??
  MEDICAID_STANDARD_ADULT_MIN_AGE
